import moment from 'moment'

export const get24HourTimeFormat = time => moment(time, ['h:mm A']).format('HH:mm')
export const get12HourTimeFormat = time => moment(time, ['HH:mm']).format('h:mm A')

export const formatMillisecondsToTime = (milliseconds = 0) => {
  const totalSeconds = Math.floor(milliseconds / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}
